import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  button: {
    height: '55px',
    borderRadius: '0 10px 10px 0'
  },
  input: {
    display: 'flex',
    width: 'fit-content'
  }
}));
